import { ApolloQueryResult } from '@apollo/client';
import config from 'config';
import {
  DonationListSort,
  GetChartsDataQuery,
  GetChartsDataQueryVariables,
  Order,
} from 'gql/types';
import { GET_CHARTS_DATA_QUERY_QUERY } from 'modules/donor/graphql/queries';
import { apolloClient } from 'providers/graphql';

export const getDonorCharts = (
  donorId: string
): Promise<ApolloQueryResult<GetChartsDataQuery>> => {
  return apolloClient.query<GetChartsDataQuery, GetChartsDataQueryVariables>({
    query: GET_CHARTS_DATA_QUERY_QUERY,
    variables: {
      input: {
        take: config.CHARTS.DEFAULT_DONATIONS_LIMIT,
        sort: [
          { fieldName: DonationListSort.LastDonationDate, order: Order.Desc },
        ],
        filter: {
          donorId,
        },
      },
    },
  });
};
